import React from "react";
import get from "lodash/get";
import {compose} from "redux";
import {Redirect, Route, Switch} from "react-router-dom";
import {rootURL} from "@unibuddy/machop/Utils/WhereAmI";
import asyncComponent from "../../../../../../machop/General/components/AsyncComponent/AsyncComponent";
import requireWidgetAuth from "../../../shared/hoc/requireWidgetAuth";
import BuddiesTab from "../../../modules/HeaderBar/tabs/BuddiesTab/BuddiesTab";
import withSocket from "./SocketData/withSocket";

// Dynamically import components for code splitting
const AsyncBlogTab = asyncComponent(() =>
    import("../../../modules/HeaderBar/tabs/BlogTab/BlogTab"),
);
const AsyncInboxTab = asyncComponent(() =>
    import("../../../modules/HeaderBar/tabs/InboxTab/InboxTabRoutes"),
);
const AsyncAuthTab = asyncComponent(() =>
    import("../../../modules/HeaderBar/tabs/AuthTab/AuthTab"),
);
const AsyncSettingsTab = asyncComponent(() =>
    import("../../../modules/HeaderBar/tabs/SettingsTab/SettingsTab"),
);

const AsyncSettingsTabWithAuth = requireWidgetAuth(AsyncSettingsTab);

const BuddiesRoutesWrapper = parentProps => (
    <Switch>
        <Route
            path={`${parentProps.match.path}/:buddyGroupType`}
            render={props => <BuddiesTab {...parentProps} {...props} />}
        />
        <Route
            exact
            path={parentProps.match.path}
            render={({location}) => (
                <Redirect
                    to={{
                        ...location,
                        pathname: `${parentProps.match.url.replace(/\/$/, "")}/students`,
                    }}
                />
            )}
        />
    </Switch>
);

const ProspectWidgetRoutes = parentProps => {
    if (get(parentProps, "location.pathname", "").includes("/auth/verify")) {
        if (!get(parentProps, "me", false) || !get(parentProps, "me.anyUser", false)) {
            return <Redirect to={`${rootURL(parentProps.location.pathname)}/auth/register`} />;
        }
    }
    return (
        <main>
            <Switch>
                <Route
                    path={`${parentProps.match.path}/buddies`}
                    render={props => <BuddiesRoutesWrapper {...parentProps} {...props} />}
                />
                <Route
                    path={`${parentProps.match.path}/blog`}
                    render={props => <AsyncBlogTab {...parentProps} {...props} />}
                />
                <Route
                    path={`${parentProps.match.path}/inbox`}
                    render={props => <AsyncInboxTab {...parentProps} {...props} />}
                />
                <Route
                    path={`${parentProps.match.path}/auth`}
                    render={props => <AsyncAuthTab {...parentProps} {...props} />}
                />
                <Route
                    exact
                    path={`${parentProps.match.path}/settings`}
                    render={props => <AsyncSettingsTabWithAuth {...parentProps} {...props} />}
                />
                <Route
                    exact
                    path={parentProps.match.path}
                    render={({location}) => (
                        <Redirect
                            to={{
                                ...location,
                                pathname: `${parentProps.match.url.replace(/\/$/, "")}/buddies`,
                            }}
                        />
                    )}
                />
            </Switch>
        </main>
    );
};

export default compose(withSocket)(ProspectWidgetRoutes);
